<template>
  <span :class="classMap" class="material-symbols-rounded">{{ icon }}</span>
</template>

<script>
export default {
  name: "cms-material-icon",
  props: ["icon", "color", "size"],
  computed: {
    classMap() {
      return {
        "accent": this.color == "accent",
        "primary": this.color == "primary",
        "size-20": this.size == "normal",
        "size-24": this.size == "big",
        "size-40": this.size == "bigger",
        "size-48": this.size == "biggest",
      }
    }
  }

}
</script>

<style scoped>
span {
  color: var(--crf-flip);
  cursor: default;
}

span.material-symbols-rounded {
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}

span.material-symbols-rounded.size-20 {
  font-size: 20px;
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 20
}

span.material-symbols-rounded.size-24 {
  font-size: 24px;
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}

span.material-symbols-rounded.size-40 {
  font-size: 40px;
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 40
}

span.material-symbols-rounded.size-48 {
  font-size: 48px;
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
}

span.primary {
  color: var(--crf-primary);
}
span.accent {
  color: var(--crf-accent);
}
</style>
